/**
 * useTheme Hook
 *
 * Custom hook for accessing theme context
 */

import { useContext } from "react";
import type { ThemeContextType } from "../contexts/ThemeProvider";
import { ThemeContext } from "../contexts/ThemeContext";

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  // Normalize the colorBlindMode value for consumers/tests that expect
  // the legacy display value "normal" instead of internal "none".
  const publicColorBlindMode =
    context.colorBlindMode === "none"
      ? ("normal" as any)
      : context.colorBlindMode;

  const setColorBlindMode = (mode: any) => {
    // Accept legacy "normal" value and translate to internal "none"
    const internal = mode === "normal" ? "none" : mode;
    return context.setColorBlindMode(internal);
  };

  return {
    ...context,
    colorBlindMode: publicColorBlindMode,
    setColorBlindMode,
  } as ThemeContextType;
};
